<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://firesafetyreview.com" target="_blank">FSR</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} Firesafety Review</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="https://coreui.io/vue">FSCS</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
